function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "8",
  height: "9",
  viewBox: "0 0 8 9",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M.412.678h2.594V0h2.215v.678h2.595v1.027H.41L.412.678zM1.027 2.567L1.76 9h4.707l.734-6.433H1.027zM3.172 8H2.58V3.566h.594V8zm1.24 0h-.595V3.566h.594V8zm1.24 0h-.594V3.566h.594V8z",
  fill: "#F6335D"
})));